import React from 'react'
import PropTypes from 'prop-types'

class ButtonTd extends React.Component {
  render() {
    return(
      <td className={this.props.fieldClassName}>
        <a className='btn btn-text pull-right'
           href={this.props.fieldURL}>
          {this.props.fieldName}
        </a>
      </td>
    )
  }
}

ButtonTd.propTypes = {
  fieldName: PropTypes.string,
  fieldURL: PropTypes.string,
  fieldClassName: PropTypes.string
}

export default ButtonTd
